import React, { Ref, forwardRef } from 'react';
import css from './Dropdown.module.css';
import clsx from 'clsx';
import { ChevronImage } from '../../../../assets/images';
import { ImageUtility } from '@mchs/web-core';

export interface DropdownOption {
  text: string;
  value: string;
}

export interface DropdownProps {
  className?: string;
  selectedValue?: string;
  options: DropdownOption[];
  disabled?: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onItemPicked: (item: string) => void;
}

const backgroundImage = ImageUtility.wrapSourceWithUrl(ChevronImage);

const DropdownComponent: React.ForwardRefRenderFunction<
  HTMLSelectElement,
  DropdownProps
> = (props: DropdownProps, ref: Ref<HTMLSelectElement>) => {
  const { disabled = false } = props;
  const onChangeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    props.onItemPicked(event.target.value as string);
  };

  return (
    <select
      ref={ref}
      className={clsx(css.dropdown, props.className)}
      style={{ backgroundImage }}
      disabled={disabled}
      value={props.selectedValue}
      onChange={onChangeSelect}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
    >
      {props.options?.map((option, index) => (
        <option key={index} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  );
};

const Dropdown = forwardRef(DropdownComponent);

export default Dropdown;
